/* eslint-disable react/no-danger */
import React, { useState } from 'react';
import {
  Card,
  Box,
  HeadingText,
  GDSStyleObject,
  Button,
  ParagraphText,
} from '@leagueplatform/genesis-core';
import { LoadingIndicator } from '@leagueplatform/web-common-components';
import { useStaticAsset } from '@leagueplatform/asset-config';
import { EVENT_NAME, trackAnalyticsEvent } from '@leagueplatform/analytics';
import { HtmlToReact } from '@leagueplatform/web-common';
import { FORMS_LIBRARY_ASSET_KEYS } from '../../types/forms-library.types';

export function FormsReusableComponent(props: any) {
  const { formData, openForm, groupNumber, isPdfLoading } = props;
  const {
    headingText,
    description,
    altFormIdentifiers,
    details,
    instructions,
    forms,
    formType,
  } = formData;

  const [formURL, setFormURL] = useState('');
  const formIcon = useStaticAsset(FORMS_LIBRARY_ASSET_KEYS.FORM_ICON);
  const replaceWithBr = (data: string) => data.replace(/\n/g, '<br />');
  const listComp = (listArr: any) => (
    <ul
      style={{
        listStyle: 'unset',
      }}
    >
      {listArr.map((item: string, index: any) => (
        // eslint-disable-next-line react/no-array-index-key
        <li key={index}>
          <HtmlToReact htmlString={replaceWithBr(item)} />
        </li>
      ))}
    </ul>
  );

  const trackAnalytics = (
    buttonName: string,
    tab: string,
    identifier: string,
  ) => {
    trackAnalyticsEvent(EVENT_NAME.BUTTON_CLICKED, {
      detail: buttonName,
      product_area: tab,
      sub_product_area: identifier,
      screen_name: 'Forms Library',
      path: window.location.pathname,
      event_author: 'engen',
    });
  };

  const handleClick = (form: any) => {
    setFormURL(form.url);
    openForm(
      form.type,
      form.url,
      headingText,
      form.prefillInfo,
      groupNumber,
      form.title,
    );
    trackAnalytics(form.title, formType, headingText);
  };
  return (
    <Card.Elevated
      backgroundColor="primary"
      css={
        {
          margin: '12px auto',
          '@laptop': { gridTemplateColumns: '77% 23%' },
        } as GDSStyleObject
      }
    >
      <Card.Section>
        <Box
          data-testid="Form-structure"
          css={
            {
              display: 'grid',
              '@laptop': { gridTemplateColumns: '77% 23%' },
              '@desktop': { gridTemplateColumns: '77% 23%' },
            } as GDSStyleObject
          }
        >
          <Box>
            <HeadingText
              data-testid="heading-test"
              size="md"
              level="3"
              css={
                {
                  display: 'inline-flex',
                } as GDSStyleObject
              }
            >
              <span
                style={{
                  display: 'grid',
                  alignItems: 'center',
                  height: '108px',
                }}
              >
                {headingText}
              </span>
            </HeadingText>
            <ParagraphText>
              {description &&
                description.map((desc: string) => <p key={desc}>{desc}</p>)}
              <p>
                {altFormIdentifiers.titles && (
                  <>
                    <span style={{ fontStyle: 'italic' }}>
                      {altFormIdentifiers.descriptorText}
                    </span>{' '}
                    <span>{altFormIdentifiers.titles.join(', ')}</span>
                  </>
                )}
              </p>
              <p style={{ marginLeft: '20px' }}>{listComp(details)}</p>
            </ParagraphText>
          </Box>
          <Box
            css={
              {
                '@laptop': { marginTop: '24px' },
                '@desktop': { marginTop: '24px' },
              } as GDSStyleObject
            }
          >
            <Box
              css={{
                width: '242px',
                display: 'block',
              }}
            >
              {forms.map((form: any) => (
                <Button
                  data-testid="forms-event"
                  key={form.headingText}
                  css={
                    {
                      height: '60px',
                      marginBottom: '12px',
                    } as GDSStyleObject
                  }
                  onClick={() => handleClick(form)}
                >
                  <span
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      padding:
                        form.title === 'PDF Form' ? '15px 8px' : '15px 0px',
                    }}
                  >
                    <img
                      src={formIcon as string}
                      alt="Visual Icon"
                      height="24px"
                      style={{
                        marginRight: '12px',
                      }}
                    />
                    {form.title}
                  </span>
                  {isPdfLoading &&
                    formURL === form?.url &&
                    form?.url &&
                    formURL && (
                      <Box
                        css={{
                          '& >.genesis': {
                            zIndex: 2,
                            background: 'rgba(255, 255, 255, 0.3)',
                            position: 'fixed',
                          } as GDSStyleObject,
                        }}
                      >
                        <LoadingIndicator />
                      </Box>
                    )}
                </Button>
              ))}
            </Box>
          </Box>
        </Box>
        {instructions && (
          <Card.Elevated
            backgroundColor="highlight"
            css={
              {
                marginTop: '18px',
              } as GDSStyleObject
            }
          >
            <Card.Section
              css={
                {
                  padding: '6px',
                } as GDSStyleObject
              }
            >
              {instructions.map((inst: any) => (
                <div key={inst}>
                  {inst.type === 'email' ? (
                    <p>
                      {inst.descriptorText}&nbsp;
                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                      <a href="">{inst.contents[0]}</a>
                    </p>
                  ) : (
                    // eslint-disable-next-line react/jsx-no-useless-fragment
                    <>
                      {inst.type === 'fax' ? (
                        <>
                          <p>{inst.descriptorText}</p>
                          <p>{inst.contents.map((con: any) => `${con} `)}</p>
                        </>
                      ) : (
                        <>
                          <p>{inst.descriptorText}</p>
                          {inst.contents.map((content: string) => (
                            <p style={{ margin: 0 }} key={content}>
                              {content}
                            </p>
                          ))}
                        </>
                      )}
                    </>
                  )}
                </div>
              ))}
            </Card.Section>
          </Card.Elevated>
        )}
      </Card.Section>
    </Card.Elevated>
  );
}
